import React, { useState, Fragment } from "react";
import { supabase } from "../../../lib/supabaseClient";

const Login = (props) => {
  const [showPassword, setShowPassword] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGoogleLogin = async () => {
    setError("");
    const { error: oauthError } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: window.location.origin },
    });
    if (oauthError) setError("Error al iniciar sesión con Google. Intenta de nuevo.");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Por favor completa todos los campos.");
      return;
    }
    setLoading(true);
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (signInError) {
      setError("Correo o contraseña incorrectos.");
      return;
    }
    setEmail("");
    setPassword("");
    props.onCLickModalLogin();
  };

  return (
    <Fragment>
      <div
        className={"wrapper__modal-wrap modal fade " + (props.modalLogin ? "show" : "")}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="close__wrap pointer d-lg-none mx-auto" onClick={() => props.onCLickModalLogin()}>
          <img src="./../images/sdd.png" alt="" />
        </div>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content position-relative">
            <div className="close__wrap pointer d-none d-lg-flex" onClick={() => props.onCLickModalLogin()}>
              <img src="./../images/sdd.png" alt="" />
            </div>
            <div className="text-center">
              <img src="./../images/Listopagologo.png" alt="" style={{ width: '180px', height: 'auto' }} />
            </div>
            <h4 className="semi-bold font__size--32 text__32-1024 mt-4 mb-0">Bienvenido</h4>
            <hr className="line__hr" />

            {error && (
              <div className="alert alert-danger font__size--14 py-2 mb-3" role="alert">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="login-email" className="semi-bold font__size--14 text__14-1024">Correo electrónico</label>
              <div className="wrapper__field-wrap">
                <input
                  id="login-email"
                  type="email"
                  className="form-control medium font__size--16 text__16-1024"
                  placeholder="Ingresa tu correo"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="login-password" className="semi-bold font__size--14 text__14-1024">Contraseña</label>
              <div className="wrapper__field-wrap d-flex align-items-center justify-content-between">
                <input
                  id="login-password"
                  type={showPassword ? "password" : "text"}
                  className="form-control medium font__size--16 text__16-1024"
                  placeholder="Ingresa tu contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin(e)}
                />
                <img src="./../images/eye-slash.png" className="pointer" onClick={() => setShowPassword(!showPassword)} alt="" />
              </div>
            </div>

            <div className="font__size--14 text__14-1024 medium mb-3">
              <span
                className="d-inline-block color__purple pointer"
                onClick={() => props.onCLickSwitchModal("forgotPassowrd")}
              >
                ¿Olvidaste tu contraseña?
              </span>
            </div>

            <button
              className="btn btn__purple shadow color__white w-100 font__size--14 text__14-1024 medium rounded__12 position-relative z-2"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Ingresando..." : "Iniciar sesión"}
            </button>

            <div className="d-flex align-items-center my-3">
              <hr style={{ flex: 1, borderColor: '#e5e5e7' }} />
              <span className="mx-3 medium font__size--13 color__gray-1">o</span>
              <hr style={{ flex: 1, borderColor: '#e5e5e7' }} />
            </div>

            <button
              type="button"
              className="btn w-100 medium font__size--14 text__14-1024 rounded__12 d-flex align-items-center justify-content-center"
              style={{ border: '1px solid #e5e5e7', background: 'white', gap: 10, padding: '10px 20px' }}
              onClick={handleGoogleLogin}
            >
              <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                <path fill="none" d="M0 0h48v48H0z"/>
              </svg>
              Continuar con Google
            </button>

            <div className="mt-4 text-center medium font__size--14 text__14-1024">
              ¿No tienes cuenta?{" "}
              <span className="color__purple pointer" onClick={() => props.onCLickSwitchModal("register")}>
                Crear cuenta
              </span>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
